import { observer } from "mobx-react";
import { useEffect } from "react";
import triggerResize from "../../Core/triggerResize";
import { useViewState } from "../Context";
import NotificationToast from "./NotificationToast";
import NotificationWindow from "./NotificationWindow";
import { jsx as _jsx } from "react/jsx-runtime";
const Notification = observer(() => {
  var _notification$ignore, _notification$type;
  const viewState = useViewState();
  const notificationState = viewState === null || viewState === void 0 ? void 0 : viewState.terria.notificationState;
  const notification = notificationState === null || notificationState === void 0 ? void 0 : notificationState.currentNotification;
  const ignore = typeof (notification === null || notification === void 0 ? void 0 : notification.ignore) === "function" ? notification.ignore() : (_notification$ignore = notification === null || notification === void 0 ? void 0 : notification.ignore) !== null && _notification$ignore !== void 0 ? _notification$ignore : false;
  useEffect(() => {
    if (ignore) {
      notificationState.dismissCurrentNotification();
    }
  }, [notificationState, ignore]);
  if (viewState === undefined || notificationState === undefined || notification === undefined) {
    return null;
  }
  const close = () => {
    // Force refresh once the notification is dispatched if .hideUi is set since once all the .hideUi's
    // have been dispatched the UI will no longer be suppressed causing a change in the view state.
    if (notification.hideUi) {
      triggerResize();
    }
    notificationState.dismissCurrentNotification();
  };
  const confirm = () => {
    if (notification.confirmAction !== undefined) {
      notification.confirmAction();
    }
    close();
  };
  const deny = () => {
    if (notification.denyAction !== undefined) {
      notification.denyAction();
    }
    close();
  };
  return notification.showAsToast ? /*#__PURE__*/_jsx(NotificationToast, {
    notification: notification
  }) : /*#__PURE__*/_jsx(NotificationWindow, {
    viewState: viewState,
    title: notification.title,
    message: notification.message,
    confirmText: notification.confirmText,
    denyText: notification.denyText,
    onConfirm: confirm,
    onDeny: deny,
    type: (_notification$type = notification.type) !== null && _notification$type !== void 0 ? _notification$type : "notification",
    width: notification.width,
    height: notification.height
  });
});
export default Notification;